export var PageType = {
  Details: 'DTL',
  SearchResults: 'SRP',
  Homepage: 'HP',
  News: 'NEWS',
  Research: 'RES'
};
export var Section = {
  Rent: 'RENT',
  Buy: 'BUY',
  Sold: 'SOLD',
  NewHomes: 'NH',
  Commercial: 'COMM',
  Index: 'IDX',
  Article: 'ART',
  Report: 'REPORT',
  Glossary: 'GLOSSARY'
};